import { Badge, Grid } from "@material-ui/core";
import { AlertTriangle, Check, Gift, Heart, Snowflake, Sparkles, Star, Thermometer, Wine, Zap } from "lucide-react";

import MarketplaceFestaJuninaHeader from "../../../../components/marketplace/specialEvents/festaJunina/marketplaceFestaJuninaHeader";

import datetimeProvider from "../../../../providers/datetime.provider";
import { packages } from "../../../constant/marketing/product.constant";
import eventAbsoluto2026Config from "./events.configs/event.absoluto.2026.config";
import eventChristmas2025Config from "./events.configs/event.christmas.2025.config";
import eventCopa2026Config from "./events.configs/event.copa.2026.config";
import eventDiaAdvogado2026Config from "./events.configs/event.dia.advogado.2026.config";
import eventSmart2026Config from "./events.configs/event.smart.2026.config";

export const premiosFestaJunina = [
    {
        key: "peticaoExpress",
        label: "Petição Express",
        color: "#dc2626",
        percentChance: 80,
        deliveryType: 'automatic',
    },
    {
        key: "antecipacao24h",
        label: "Antecipação 24h",
        color: "#ea580c",
        percentChance: 80,
        deliveryType: 'automatic',
    },
    {
        key: "calculos350",
        label: "Cálculos R$350",
        color: "#ca8a04",
        percentChance: 15,
        deliveryType: 'automatic',
    },
    {
        key: "pix100reais",
        label: "Pix de R$100",
        color: "#16a34a",
        percentChance: 15,
        deliveryType: 'manual',
    },
    {
        key: "peticaoGratis",
        label: "1 Petição Grátis",
        color: "#2563eb",
        percentChance: 80,
        deliveryType: 'automatic',
    },
    {
        key: "desconto15",
        label: "15% OFF",
        subLabel: "(Em qualquer pacote)",
        color: "#7c3aed",
        percentChance: 80,
        deliveryType: 'automatic',
    },
    {
        key: "cestaJunina",
        label: "Cesta Junina",
        color: "#db2777",
        percentChance: 5,
        deliveryType: 'manual',
    },
    {
        key: "vinhoPorto",
        label: "Vinho do Porto",
        color: "#0891b2",
        percentChance: 5,
        deliveryType: 'manual',
    },
];

export const yearlyEvents = {
    blackFriday: {
        key: 'blackfriday',
        label: 'Black Friday',
        initialDate: '2024-11-11',
        finalDate: '2024-11-17',
        colors: {
            primary: '#131313',
            secondary: '#333',
        },
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
    },
    valentinesDay: {
        key: 'valentinesday',
        initialDate: '2025-06-01',
        finalDate: '2025-06-12',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: () => (
            <div className="w-full text-center">
                <div className="flex items-center justify-center gap-2 mb-4">
                    <Heart className="w-8 h-8 text-red-500 fill-red-500" />
                    <h1 className="text-4xl font-bold bg-gradient-to-r from-red-500 to-pink-500 bg-clip-text text-transparent">
                        Especial Dia dos Namorados
                    </h1>
                    <Heart className="w-8 h-8 text-red-500 fill-red-500" />
                </div>
                <p className="text-xl text-gray-600 mb-6">
                    Sabemos que entre prazos, petições e audiências o tempo com quem você ama pode acabar ficando em segundo
                    plano. Isso pode mudar agora! Todos os pacotes com{" "}
                    <span className="font-bold text-red-500">10% de desconto</span>
                </p>

                <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white p-6 rounded-2xl shadow-lg max-w-4xl mx-auto">
                    <div className="flex items-center justify-center gap-4 mb-3">
                        <Gift className="w-8 h-8" />
                        <h2 className="text-2xl font-bold">Sorteio Especial!</h2>
                        <Wine className="w-8 h-8" />
                    </div>
                    <p className="text-lg font-[350]">
                        Contrate qualquer pacote e concorra a uma <span className="font-bold">cesta com vinhos e chocolates</span>{" "}
                        para comemorar com seu amor!
                    </p>
                    <p className="text-sm mt-2 opacity-90">
                        Sorteio realizado no dia <span className="font-bold">12/06/2024</span>
                    </p>
                </div>
            </div>
        ),
        footer: () => (
            <div className="w-full mt-12 text-center">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <Heart className="w-6 h-6 text-red-500 fill-red-500" />
                        <p className="text-lg font-semibold text-gray-800">Oferta válida por tempo limitado</p>
                        <Heart className="w-6 h-6 text-red-500 fill-red-500" />
                    </div>
                    <p className="text-gray-600">
                        Oferta válida somente até o dia <span className="font-bold">12/06/2025</span>. Aproveite o desconto especial
                        do Dia dos Namorados e automatize seu escritório com economia!
                    </p>
                </div>
            </div>
        ),
        backgroundColor: '#fdf2f7'
    },
    festaJunina: {
        key: 'festaJunina',
        initialDate: '2025-06-13',
        finalDate: '2025-06-30',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: () => <MarketplaceFestaJuninaHeader roulettePrizes={premiosFestaJunina} />,
        footer: () => (
            <div className="w-full mt-12 text-center">
                <div className="bg-gradient-to-r from-amber-100 to-orange-100 p-6 rounded-xl shadow-lg border-2 border-amber-200">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <div className="w-6 h-6 bg-amber-500 rounded-full flex items-center justify-center">
                            <Star className="w-4 h-4 text-white fill-white" />
                        </div>
                        <p className="text-lg font-semibold text-gray-800">Arraiá válido por tempo limitado!</p>
                        <div className="w-6 h-6 bg-amber-500 rounded-full flex items-center justify-center">
                            <Star className="w-4 h-4 text-white fill-white" />
                        </div>
                    </div>
                    <p className="text-gray-600">
                        Venha pro arraiá mais animado do mundo jurídico! Automatize seu escritório e ainda teste sua sorte na nossa
                        roleta!
                    </p>
                </div>
            </div>
        ),
        backgroundColor: '#fffaeb',
        packages: {
            [packages.premium.id]: {
                tag: () => (
                    <div className="rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary hover:bg-primary/80 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm px-3 py-1 flex items-center gap-1 z-30">
                        <Sparkles className="w-3 h-3" />
                        <span>Gire a Roleta!</span>
                    </div>
                )
            },
            [packages.infinity.id]: {
                tag: () => (
                    <div className="rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary hover:bg-primary/80 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm px-3 py-1 flex items-center gap-1 z-30">
                        <Sparkles className="w-3 h-3" />
                        <span>Gire a Roleta!</span>
                    </div>
                )
            },
        },

    },
    winter: {
        key: 'winter',
        initialDate: '2025-07-01',
        finalDate: '2025-07-13',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        backgroundColor: '#F3F8FE',
        header: () => (
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                    <span className="text-blue-500">❄</span> 👉 Congelou no Operacional? Aquece com a Facilita!
                </h1>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-8 font-medium">
                    Não deixe seu escritório congelar nesse inverno! Dê um basta na sobrecarga: descongele sua rotina com
                    pacotes que agilizam prazos, organizam demandas e devolvem seu tempo.
                </p>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                description: 'Está começando a automatizar sua advocacia e quer sair da rotina congelada? O Plano Start é o primeiro passo para quem quer aquecer a produtividade e focar no que realmente importa: crescer. Comece agora com flexibilidade e sem complicações.',
                icon: Snowflake
            },
            [packages.premium.id]: {
                description: 'Seu escritório não pode esfriar. O Plano Premium foi criado para advogados e equipes que querem aumentar o volume de trabalho com agilidade, controle e sem sustos com prazos. Aqueça sua estrutura com tecnologia, atendimento humanizado e entregas mais rápidas.',
                icon: Thermometer
            },
            [packages.infinity.id]: {
                description: 'Chega de rotina congelada por falta de estrutura. O Plano Infinity é para escritórios que desejam crescer de forma robusta e inteligente, com máxima velocidade, tecnologia e entrega prioritária. Com esse plano, a Facilita se transforma em uma extensão quente e estratégica do seu time.',
                icon: Zap
            }
        }
    },
    july: {
        key: 'july',
        initialDate: '2025-07-14',
        finalDate: '2025-07-31',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: () => (
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-4xl text-gray-900 mb-8">
                    <span className="font-bold">Atenção: condição válida somente até o final de julho!</span> <br />
                    Seu escritório precisa de mais velocidade e nós entregamos com mais agilidade.
                </h1>
                <p className="text-xl text-gray-500 max-w-4xl mx-auto leading-relaxed mb-8">
                    Os pacotes Start, Premium e Infinity agora contam com suas versões <span className="font-bold">Plus</span>, entregando suas petições em tempo recorde e sem aumento de preço. <span className="font-bold">Cadastros feitos em todo o mês de julho</span> entram no <span className="font-bold">Ranking de Produtividade</span>. O campeão leva um notebook!
                </p>
            </div>
        ),
        packages: {
            [packages.premium.id]: {
                name: 'Premium Plus',
                tag: (packageGradient) => (
                    <div
                        class="absolute top-0 right-4 text-slate-50 text-sm px-3 py-1 rounded-b-lg font-medium text-wrap text-center z-10"
                        style={{ background: packageGradient }}
                    >
                        <span>Pacote Plus disponível</span>
                    </div>
                )
            },
            [packages.infinity.id]: {
                name: 'Infinity Plus',
                tag: (packageGradient) => (
                    <div
                        class="absolute top-0 right-4 text-slate-50 text-sm px-3 py-1 rounded-b-lg font-medium text-wrap text-center z-10"
                        style={{ background: packageGradient }}
                    >
                        <span>Pacote Plus disponível</span>
                    </div>
                )
            },
            [packages.start.id]: {
                name: 'Start Plus',
                tag: (packageGradient) => (
                    <div
                        class="absolute top-0 right-4 text-slate-50 text-sm px-3 py-1 rounded-b-lg font-medium text-wrap text-center z-10"
                        style={{ background: packageGradient }}
                    >
                        <span>Pacote Plus disponível</span>
                    </div>
                )
            },
        },
    },
    lawyerWeek: {
        key: 'lawyerWeek',
        initialDate: '2025-08-11',
        finalDate: '2025-08-17',
        eventVoucherCode: 'ADV10',
        eventVoucherDiscount: 0.1, // 10%
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: (primaryColor) => (
            <div className="flex flex-col items-center text-center mb-16">
                <div className="max-w-2xl">
                    <div className="my-4">
                        <Badge variant="secondary" className="mb-4 bg-blue-100 font-[600] text-blue-800 px-2 py-1 rounded-lg">
                            Semana do Advogado
                        </Badge>
                    </div>

                    <div className="flex gap-6 items-center text-[#131313]">
                        <Grid item style={{ marginTop: '10px' }}>
                            <div className={`text-lg font-semibold leading-none text-[${primaryColor}]`}>
                                Mais de <span className="">9 mil</span> advogados confiam na Facilita Jurídico hoje
                            </div>

                            <div className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl leading-none">
                                Seu escritório vai ainda mais rápido com a Facilita Jurídico!
                            </div>
                        </Grid>
                    </div>

                    <div className="mt-7 text-xl tracking-tight text-[#13131399]">
                        Deixe as demandas jurídicas nas nossas mãos e durma tranquilamente. Agora com velocidade especial da Semana do Advogado.
                    </div>
                </div>
            </div>
        ),
        additionalMessage: () => (
            <div className="text-center mb-12">
                <p className="text-lg text-blue-700">
                    💡 Lembre-se de aplicar o cupom <strong>ADV10</strong> no checkout para garantir seu desconto especial da Semana do Advogado.
                </p>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                name: 'Start Ultra',
                dueDateBenefit: {
                    main: 'Entrega em 3 dias úteis',
                }
            },
            [packages.premium.id]: {
                name: 'Premium Ultra',
                dueDateBenefit: {
                    main: 'Entrega em 2 dias úteis',
                }
            },
            [packages.infinity.id]: {
                name: 'Infinity Ultra',
                dueDateBenefit: {
                    main: 'Entrega em 1 dia útil',
                }
            }
        }
    },
    nowItsPlus: {
        key: 'nowItsPlus',
        initialDate: '2025-08-20',
        finalDate: '2025-09-30',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: (primaryColor) => (
            <div className="flex flex-col items-center text-center mb-16 mt-12">
                <div className="max-w-3xl">
                    <div className="my-4">
                        <Badge variant="secondary" className="mb-2 bg-indigo-50 font-[500] text-indigo-600 px-2 rounded-lg border border-indigo-200 flex items-center py-0.5">
                            <Sparkles className="w-3 h-3 mr-2" />
                            Edição limitada até 30/09
                        </Badge>
                    </div>

                    <div className="flex gap-6 items-center text-[#131313]">
                        <div className="mt-2 text-4xl font-semibold tracking-tight sm:text-6xl leading-none">
                            Deixe seu escritório no <span className="bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent">piloto automático</span> com ainda mais liberdade e velocidade
                        </div>
                    </div>

                    <div className="mt-10 text-xl tracking-tight text-[#13131399]">
                        ⚡️ Agora os pacotes Start+, Premium+ e Infinity+ têm validade de 1 ano e prazos de entrega reduzidos, sem custo adicional.
                    </div>

                </div>

                <div className="mt-12 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl p-8 mb-12 max-w-4xl mx-auto">
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-lg font-semibold">
                        <div className="flex items-center text-green-700">
                            <Check className="w-6 h-6 mr-2" />
                            <span>sem assinatura</span>
                        </div>
                        <div className="flex items-center text-green-700">
                            <Check className="w-6 h-6 mr-2" />
                            <span>sem taxa de adesão</span>
                        </div>
                        <div className="flex items-center text-green-700">
                            <Check className="w-6 h-6 mr-2" />
                            <span>liberdade máxima para crescer</span>
                        </div>
                    </div>
                </div>
            </div>
        ),
        additionalMessage: () => (
            <div className="text-center mb-12">
                <div className="bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-lg p-4 max-w-2xl mx-auto">
                    <div className="flex items-center justify-center mb-4">
                        <AlertTriangle className="w-6 h-6 text-red-600 mr-3" />
                        <div className="bg-red-100 text-red-700 border border-red-200 px-2 py-0.5 rounded-lg font-semibold">Edição Limitada válida até 30/09</div>
                    </div>
                    <p className="text-slate-800 text-[16px]">
                        Aproveite para ter 1 ano de liberdade + entrega acelerada sem pagar a mais. <br />
                        Sem assinatura, sem taxa de adesão, liberdade máxima para você crescer.
                    </p>
                </div>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                name: 'Start+',
                description: 'Para quem está começando a automatizar a advocacia com mais liberdade.',
                dueDateBenefit: {
                    main: 'Entrega em 3 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.premium.id]: {
                name: 'Premium+',
                description: 'Para quem precisa escalar a operação com agilidade e segurança.',
                dueDateBenefit: {
                    main: 'Entrega em 2 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.infinity.id]: {
                name: 'Infinity+',
                description: 'Para escritórios que buscam escala, eficiência e agilidade máxima.',
                dueDateBenefit: {
                    main: 'Entrega em 1 dia útil',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            }
        }
    },
    maxPackages: {
        key: 'maxPackages',
        initialDate: '2025-10-01',
        finalDate: '2025-10-31',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: (primaryColor) => (
            <div className="flex flex-col items-center text-center mb-16 mt-12">
                <div className="max-w-4xl">
                    <div className="my-4">
                        <Badge variant="secondary" className="mb-2 bg-indigo-50 font-[500] text-indigo-600 px-2 rounded-lg border border-indigo-200 flex items-center py-0.5">
                            <Sparkles className="w-3 h-3 mr-2" />
                            Edição limitada até 31/10
                        </Badge>
                    </div>

                    <div className="flex gap-6 items-center text-[#131313]">
                        <div className="mt-2 text-4xl font-semibold tracking-tight sm:text-6xl leading-none">
                            Acelere sua advocacia com os <span className="bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent">Pacotes Max</span> da Facilita Jurídico!
                        </div>
                    </div>

                    <div className="mt-10 text-xl tracking-tight text-[#090909c1]">
                        Tenha uma máquina de petições, cálculos, audiências e traduções juramentadas, tudo em um só lugar.
                    </div>

                    <div className="mt-5 text-xl tracking-tight text-[#13131399]">
                        Prazos turbinados, revisões ilimitadas e descontos exclusivos nas audiências presenciais e cálculos complexos. Escolha o pacote ideal e comece agora mesmo.
                    </div>

                </div>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                name: 'Start Max',
                dueDateBenefit: {
                    main: 'Entrega em 3 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.premium.id]: {
                name: 'Premium Max',
                dueDateBenefit: {
                    main: 'Entrega em 2 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.infinity.id]: {
                name: 'Infinity Max',
                dueDateBenefit: {
                    main: 'Entrega em 1 dia útil',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            }
        }
    },
    blackNovember: {
        key: 'blackNovember',
        initialDate: '2025-11-03',
        finalDate: '2025-11-09',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: (primaryColor) => (
            <div className="flex flex-col items-center text-center mb-16 mt-12">
                <div className="max-w-4xl">
                    <div className="my-4">
                        <Badge variant="secondary" className="mb-2 bg-black/90 font-[600] text-white px-2 rounded-lg border border-black flex items-center py-0.5 shadow-lg shadow-black/20 uppercase tracking-wide">
                            <Sparkles className="w-3 h-3 mr-2 text-yellow-400" />
                            Condição histórica até o dia <span className="font-bold ml-1">09/11</span>
                        </Badge>
                    </div>

                    <div className="flex gap-6 items-center text-[#131313]">
                        <div className="mt-2 text-4xl font-semibold tracking-tight sm:text-6xl leading-none">
                            Ative o modo liberdade na sua advocacia com a <span className="bg-gradient-to-r from-gray-900 to-gray-500 bg-clip-text text-transparent">
                                Black November Facilita!
                            </span>
                        </div>
                    </div>

                    <div className="mt-10 text-xl tracking-tight text-[#090909c1]">
                        Nunca mais fique preso nos prazos ou desesperado na sobrecarga do seu operacional. Agora você pode ter mais liberdade e velocidade para se concentrar em lojas e clientes.
                    </div>

                    <div className="mt-5 text-xl tracking-tight text-[#131313]">
                        Ganhe mais tempo livre e aumente seu faturamento com os nossos Pacotes Blacks, entregas aceleradas em todos os docs jurídicos e desconto especial de 10% com o cupom <strong>BLACK10</strong>!
                    </div>

                </div>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                name: 'Start Black',
                dueDateBenefit: {
                    main: 'Entrega em 3 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.premium.id]: {
                name: 'Premium Black',
                dueDateBenefit: {
                    main: 'Entrega em 2 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.infinity.id]: {
                name: 'Infinity Black',
                exclusiveBenefit: () => (
                    <div class="p-3 rounded-lg border-2 border-black/5" style={{ background: `#00000016` }}>
                        <p class="text-sm font-medium" style={{ color: `#000000` }}>
                            <span className="mr-1 font-bold">Bonus Exclusivo:</span> 5 antecipações Express!
                        </p>
                    </div>
                ),
                dueDateBenefit: {
                    main: 'Entrega em 1 dia útil',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            }
        }
    },
    blackNovember2: {
        key: 'blackNovember2',
        initialDate: '2025-11-09',
        finalDate: '2025-11-25',
        validator: function () {
            return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
        },
        header: (primaryColor) => (
            <div className="flex flex-col items-center text-center mb-16 mt-12">
                <div className="max-w-4xl">
                    <div className="my-4">
                        <Badge variant="secondary" className="mb-2 bg-black/90 font-[600] text-white px-2 rounded-lg border border-black flex items-center py-0.5 shadow-lg shadow-black/20 uppercase tracking-wide">
                            <Sparkles className="w-3 h-3 mr-2 text-yellow-400" />
                            Condição histórica até o dia <span className="font-bold ml-1">30/11</span>
                        </Badge>
                    </div>

                    <div className="flex gap-6 items-center text-[#131313]">
                        <div className="mt-2 text-4xl font-semibold tracking-tight sm:text-6xl leading-none">
                            Ative o modo liberdade na sua advocacia com a <span className="bg-gradient-to-r from-gray-900 to-gray-500 bg-clip-text text-transparent">
                                Black November Facilita!
                            </span>
                        </div>
                    </div>

                    <div className="mt-10 text-xl tracking-tight text-[#090909c1]">
                        Nunca mais fique preso nos prazos ou desesperado na sobrecarga do seu operacional. Agora você pode ter mais liberdade e velocidade para se concentrar em lojas e clientes.
                    </div>

                    <div className="mt-5 text-xl tracking-tight text-[#131313]">
                        Ganhe mais tempo livre e aumente seu faturamento com os nossos <strong>Pacotes Black</strong>, entregas aceleradas em todos os docs jurídicos!
                    </div>

                </div>
            </div>
        ),
        packages: {
            [packages.start.id]: {
                name: 'Start Black',
                dueDateBenefit: {
                    main: 'Entrega em 3 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.premium.id]: {
                name: 'Premium Black',
                dueDateBenefit: {
                    main: 'Entrega em 2 dias úteis',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            },
            [packages.infinity.id]: {
                name: 'Infinity Black',
                dueDateBenefit: {
                    main: 'Entrega em 1 dia útil',
                },
                usageDaysBenefit: {
                    main: '1 ano para usar seus créditos',
                }
            }
        }
    },
    christmas2025: eventChristmas2025Config,
    copa2026: eventCopa2026Config,
    smart2026: eventSmart2026Config,
    diaDoAdvogado2026: eventDiaAdvogado2026Config,
    absoluto2026: eventAbsoluto2026Config,

    // Exemplo de outro evento
    // christmas: {
    //     key: 'christmas',
    //     label: 'Natal',
    //     initialDate: '2024-12-16',
    //     finalDate: '2024-12-30',
    //     colors: {
    //         primary: '#cc1818',
    //         secondary: '#ff6666',
    //     },
    //     validator: function () {
    //         return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
    //     },
    // },
};

export const getCurrentEvent = () => {
    return Object.values(yearlyEvents).find(event => event.validator());
}

const yearlyEventsService = {
    yearlyEvents,
    getCurrentEvent,
};

export default yearlyEventsService;